function CancelCampaignModalController($scope, $uibModalInstance, campaign){
    var self = this;

    self.initialise = function () {
        $scope.campaignName = campaign.Name;
    };

    $scope.confirmCancellation = function () {
        $uibModalInstance.close(true);
    };
    $scope.abortCancellation = function () {
        $uibModalInstance.close(false);
    };

    self.initialise();
}
angular
    .module('dashboard')
    .controller('CancelCampaignModalController', ['$scope', '$uibModalInstance', 'campaign', CancelCampaignModalController]);
